export default {
  and: "and",
  between: "between",
  text1: "Maintenance is scheduled",
  text2: "We hope you will not be too inconvenienced by this.",
  title: "Notice!",
}
